import React from 'react';
import { useLocationContext } from '../../context/LocationContext';

type Props = {
  children: React.ReactNode;
};

export default function LocationWrapper({ children }: Props) {
  const { isExcludedLocation } = useLocationContext();

  return isExcludedLocation ? (
    <div
      data-qa="location-wrapper"
      data-testid="location-wrapper"
      className="pt-24"
    >
      {children}
    </div>
  ) : null;
}
